module.exports = __webpack_public_path__ + "static/img/menu_pattern3-min.a7bb228.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu_pattern3-min.png
// module id = qx4o
// module chunks = 0